export const shortenedString = (address) => {
  if (!address) return '';
  const start = address.slice(0, 2);
  const end = address.slice(-4);
  return `${start}*****${end}`;
};
